import { MENU } from "../../Constants/Endpoints";
import { ApiRequestInterceptor } from "../apiRequest";
import { normalizeResponse } from "../normalizeResponse";

const porId = (seccionId) => MENU.seccionById.replace("{seccionId}", encodeURIComponent(seccionId));

export const fetchCreateSeccion = async (body) => {
  const response = await ApiRequestInterceptor(MENU.secciones, "POST", body);
  return normalizeResponse(response, "No se pudo crear la sección");
};

export const fetchUpdateSeccion = async (seccionId, body) => {
  const response = await ApiRequestInterceptor(porId(seccionId), "PUT", body);
  return normalizeResponse(response, "No se pudo guardar la sección");
};

export const fetchDeleteSeccion = async (seccionId) => {
  const response = await ApiRequestInterceptor(porId(seccionId), "DELETE");
  return normalizeResponse(response, "No se pudo eliminar la sección");
};
